<div *ngFor="let field of subFormFields; trackBy: trackByFunction" class="parameter-row-divider">
  <app-params-field [parameterField]="field.parameter" [controlField]="field.control"></app-params-field>
</div>
